import { makeStyles } from '@material-ui/core/styles';
import { COLOR_BACKGROUND_1, COLOR_PRIMARY_1, COLOR_PRIMARY_2, SIDEBAR_COLOR } from 'src/utils/colors';
import {
  COLOR_PRIMARY_DARK,
  SIDE_BAR_Z_INDEX,
  TOP_BANNER_PADDING,
  TOP_BANNER_PADDING_MOBILE,
  sidebarClosedWidth,
  sidebarWidth,
} from 'src/utils/const';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  logoButton: {
    paddingLeft: 10,
    paddingTop: 10,
  },
  logo: {
    width: 130,
    height: 40,
    mixBlendMode: 'multiply',
  },
  logoMini: {
    paddingLeft: 10,
    paddingTop: 10,
    width: 50,
    height: 50,
    mixBlendMode: 'multiply',
    objectFit: 'contain',
  },
  toolbarLogoMini: {
    paddingTop: 10,
    width: 40,
    height: 40,
  },
  hide: {
    display: 'none',
  },
  paperDrawer: {
    backgroundColor: SIDEBAR_COLOR,
    position: 'fixed',
    overflowX: 'hidden',
    zIndex: SIDE_BAR_Z_INDEX,
  },
  drawer: {
    flexShrink: 0,
    whiteSpace: 'nowrap',
    overflowX: 'hidden',
  },
  drawerOpen: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    width: sidebarWidth,
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: sidebarClosedWidth,
    [theme.breakpoints.down(900)]: {
      display: 'none',
    },
  },
  bannerOpen: {
    top: TOP_BANNER_PADDING,
    [theme.breakpoints.down(630)]: {
      top: TOP_BANNER_PADDING_MOBILE,
    },
  },
  switch: {
    position: 'fixed',
    top: theme.spacing(8),
    left: sidebarWidth - 12,
    zIndex: 5000,
    cursor: 'pointer',
    fontSize: 30,
    filter: 'drop-shadow(0px 1px 2px #000000)',
    transition: theme.transitions.create('left', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  switchClosed: {
    position: 'fixed',
    top: theme.spacing(8),
    left: theme.spacing(6),
    zIndex: 5000,
    cursor: 'pointer',
    fontSize: 30,
    filter: 'drop-shadow(0px 1px 2px #000000)',
    transition: theme.transitions.create('left', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  sideBar: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 10,
    paddingBottom: 10,
    display: 'flex',
    justifyContent: 'center',
  },
  sidebarText: {
    fontSize: 10,
    // paddingLeft: 20,
    color: '#000',
  },
  sidebarTextSelected: {
    fontSize: 10,
    // paddingLeft: 20,
    color: COLOR_PRIMARY_2,
  },
  sidebarTextBuzz: {
    fontSize: 14,
    paddingLeft: 20,
    color: '#000',
    animation: 'buzz-out 0.75s linear 1',
  },
  sidebarIconBuzz: {
    animation: 'buzz-out 0.75s linear 1',
  },
  toolbar: {
    width: sidebarWidth,
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 10,
    paddingBottom: 10,
  },
  toolbarText: {
    fontSize: 16,
    color: '#ffffff',
  },
  divider: {
    background: '#fff',
    height: 2,
    marginTop: 5,
  },
  select: {
    width: 150,
    height: 40,
    marginLeft: 20,
    marginBottom: 20,
    color: '#ffffff',
  },
  betaButton: {
    padding: '2px 5px',
    position: 'absolute',
    top: '0px',
    right: '0px',
    fontFamily: 'roboto',
    borderRadius: 200,
    border: '1px solid ' + COLOR_PRIMARY_2,
    fontSize: '10px',
    zIndex: 10,
    background: 'white',
    color: COLOR_PRIMARY_2,
  },
  betaButtonShrinked: {
    padding: '2px 5px',
    position: 'absolute',
    top: '35%',
    right: '20px',
    transform: 'translateY(-100%)',
    fontFamily: 'roboto',
    borderRadius: 200,
    border: '1px solid #000',
    fontSize: '10px',
    color: SIDEBAR_COLOR,
    background: '#000',
  },
}));

export default useStyles;
